<template>
<v-list-tile @click='$emit("selected", item)' >

  <v-list-tile-avatar
    v-if='withAvatar'
    :size='30'
    class='ma-0 mr-2 pa-0 white--text'
    color='teal'
    style='min-width:30px;' >
    <v-img v-if='profilePicture' :src='profilePicture' />
    <span v-else v-text='initials(item)' ></span>
  </v-list-tile-avatar>

  <v-list-tile-content v-if='item && item.id' >
    <v-list-tile-title>
      <v-avatar v-if='profilePicture && !withAvatar' :size='24' >
        <v-img :src='profilePicture' />
      </v-avatar>
      {{ fullname }}
      <slot name='title-chips' ></slot>
    </v-list-tile-title>
    <v-list-tile-sub-title v-if='!withAvatar' class="ml-4 pl-1" >
      {{ profession }}
    </v-list-tile-sub-title>
    <v-list-tile-sub-title v-else v-text='profession' />
  </v-list-tile-content>

  <slot name='action'></slot>
  <!-- {{item}} -->
</v-list-tile>
</template>
<script>
export default {
  name: 'PractitionerListItem',
  props: {
    item: { type: Object, required: true },
    withAvatar: { type: Boolean, default: true }
  },
  computed: {
    profilePicture () {
      if (this.item) {
        if (this.item && this.item.profile_picture) {
          let profile = this.item.profile_picture
          return this.imageKitUrl(profile, 'n-avatar_md')
        }
        if (this.item.practitioner_media && this.item.practitioner_media.profile) {
          let profile = this.item.practitioner_media.profile
          return this.imageKitUrl(profile, 'n-avatar_md')
        }
        let profile = this.getObjectPath(this.item, 'profile.profile_picture', null)
        if (profile) {
          return this.imageKitUrl(profile, 'n-avatar_md')
        }
      }
      return null
    },
    fullname () {
      if (this.item) {
        let p = this.item
        if (p.full_name) { return p.full_name }
        if (p.practitioner_name) { return p.practitioner_name }
        if (p.user && p.user.id) {
          return `${p.user.first_name} ${p.user.last_name}`
        }
        if (p.first_name) {
          return `${p.first_name} ${p.last_name}`
        }
      }
      return null
    },
    // initials () {
    //   if (this.fullname) {
    //     let items = this.fullname.split(' ')
    //     if (items && items.length > 0) {
    //       return items.slice(0, 2).map((word) => { return word[0] }).join('')
    //     }
    //   }
    //   return '??'
    // },
    profession () {
      if (this.item.profession) { return this.item.profession }
      if (this.item.practitioner_profession) { return this.item.practitioner_profession }
      let profession = this.getObjectPath(this.item, 'profile.profession.name', null)
      if (profession) { return profession }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PractitionerListItem.vue?638d30a8